import img from "../img_us/18Store banne motorisé pour terrasse de villa moderne avec piscine – solution protection solaire UNIK SYSTEM.webp"; // 🔴 adapte ton image
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Feature = ({ icon, title, text }) => (
  <div className="us-feature">
    <div data-aos="fade-up" className="us-feature-icon">{icon}</div>
    <h4 data-aos="fade-up">{title}</h4>
    <p data-aos="fade-up">{text}</p>
  </div>
);

const SectionTitle = ({ small, big }) => (
  <div className="us-section-title">
    <span data-aos="fade-up">{small}</span>
    <h2 data-aos="fade-up">{big}</h2>
  </div>
);

export default function UsStoreBannePage() {

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });

    
  }, []);

  return (
    <div className="us-page">

      {/* HERO */}
      <section className="us-hero">
        <div className="us-hero-content">
          <div data-aos="fade-right" className="us-badge">
            <h3>
              <span className="subtitle-us">US</span> <b>STORE BANNE</b>
            </h3>
          </div>

          <h1 data-aos="fade-up">Protection solaire de façade</h1>

          <p data-aos="fade-up">
            L’habillage de façade en membrane tendue US STORE BANNE
            permet de lutter efficacement contre la surchauffe des
            bâtiments en bloquant le rayonnement thermique avant qu’il
            n’atteigne les surfaces vitrées.
          </p>

          <div data-aos="zoom-in" className="us-hero-buttons">
            <a className="btn-primarya" href="/devis">
              Demander un devis
            </a>
            <a
              href="/docs/fiche-technique-us-store-banne.pdf"
              download
              className="btn-outline"
            >
              Télécharger la fiche technique
            </a>
          </div>
        </div>

        <div data-aos="fade-up" className="us-hero-image">
          <img src={img} alt="US Store Banne façade bioclimatique" />
        </div>
      </section>

      {/* DESCRIPTION */}
      <section className="us-section">
        <SectionTitle
          small="Présentation"
          big="Qu’est-ce que la solution US STORE BANNE ?"
        />

        <div className="us-two-cols">
          <p data-aos="fade-up">
            US STORE BANNE est une solution de façade bioclimatique en
            toile technique permettant de réduire l’éblouissement tout
            en conservant les apports de lumière naturelle et la vue
            vers l’extérieur.
          </p>

          <p data-aos="fade-up">
            Légère et rapide à mettre en œuvre, elle est idéale aussi
            bien en construction neuve qu’en rénovation de bâtiments
            tertiaires, commerciaux ou publics.
          </p>
        </div>
      </section>

      {/* AVANTAGES */}
      <section className="us-section us-gray">
        <SectionTitle small="Atouts" big="Avantages clés" />

        <div className="us-grid">
          <Feature
            icon="☀️"
            title="Anti-surchauffe"
            text="Réduction efficace du rayonnement thermique."
          />
          <Feature
            icon="👁️"
            title="Confort visuel"
            text="Protection contre l’éblouissement tout en gardant la vue."
          />
          <Feature
            icon="🌬️"
            title="Confort thermique"
            text="Amélioration du bien-être intérieur."
          />
          <Feature
            icon="🏗️"
            title="Idéal rénovation"
            text="Solution légère et rapide à installer."
          />
          <Feature
            icon="🛡️"
            title="Résistance climatique"
            text="Excellente tenue au vent, pluie et UV."
          />
          <Feature
            icon="♻️"
            title="Produit recyclable"
            text="Membrane compatible processus Texyloop."
          />
        </div>
      </section>

      {/* TECHNIQUE */}
      <section className="us-section">
        <SectionTitle small="Technique" big="Caractéristiques techniques" />

        <ul data-aos="fade-up" className="us-list">
          <li>Membrane technique type Soltis®</li>
          <li>Réduction du rayonnement solaire</li>
          <li>Affaiblissement acoustique en milieu urbain</li>
          <li>Résistance vent, pluie et grêle</li>
          <li>Protection UV de la façade</li>
          <li>Solution 100 % recyclable (Texyloop)</li>
        </ul>
      </section>

      {/* APPLICATIONS */}
      <section className="us-section us-gray">
        <SectionTitle small="Applications" big="Domaines d’utilisation" />

        <div className="us-tags" data-aos="fade-up">
          {[
            "Façades tertiaires",
            "Bâtiments industriels",
            "Commerces",
            "Bureaux",
            "Équipements publics",
            "Rénovation énergétique",
            "Architecture bioclimatique",
            "Façades vitrées",
          ].map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="us-cta">
        <h2>Optimisez la performance de vos façades</h2>
        <p>
          Les solutions US STORE BANNE améliorent le confort thermique
          et visuel de vos bâtiments.
        </p>
        <br />
        <a href="/contact" className="btn-primarya">
          Contactez-nous
        </a>
      </section>

    </div>
  );
}
